import { render } from "./PlaceChoice.vue?vue&type=template&id=2344b875&scoped=true"
import script from "./PlaceChoice.vue?vue&type=script&lang=js"
export * from "./PlaceChoice.vue?vue&type=script&lang=js"

import "./PlaceChoice.vue?vue&type=style&index=0&id=2344b875&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-2344b875"

export default script